import { render, staticRenderFns } from "./VerticalProgressBar.vue?vue&type=template&id=bb007778&"
import script from "./VerticalProgressBar.vue?vue&type=script&lang=js&"
export * from "./VerticalProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./VerticalProgressBar.vue?vue&type=style&index=0&id=bb007778&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports